import { head } from 'lodash/fp';
import type { ComponentProps } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getSelectedEnterpriseIntroImageId } from '../../selectors/views/selectedEnterprise/selectedEnterprise';
import type { ApplicationState } from '../../types';
import { ServerImage } from '../service';

type ServerImageProps = ComponentProps<typeof ServerImage>;

interface OwnProps extends Omit<ServerImageProps, 'id'> {
    fallbackImageId?: string | null;
    imageIds?: string[] | null;
}

const BaseRoomImage = ({ imageIds, fallbackImageId, ...other }: OwnProps) => {
    const primaryImageId = head(imageIds ?? []);
    const imageId = primaryImageId ?? fallbackImageId ?? undefined;

    return <ServerImage id={imageId} {...other} />;
};

export const RoomImage = connect(
    createStructuredSelector<ApplicationState, OwnProps, Pick<OwnProps, 'fallbackImageId'>>({
        fallbackImageId: getSelectedEnterpriseIntroImageId,
    })
)(BaseRoomImage);
